<!--培训详情统计-->
<template>
    <sub-page class="train-detail">
        <el-row :gutter="20">
            <el-col>
                <ui-card :title="$t('train.basicInfo')" icon="nucfont inuc-list-chart" class="ibox">
                    <el-row class="content_detail">
                        <el-col :span="7">
                            <ul class="info-left">
                                <li><p>{{$t('train.name')}}：</p>
                                    <p class="info-des">{{trainDetail.name||$t('c.none')}}</p></li>
                                <li>培训专题：<span>{{trainDetail.specialName||$t('c.none')}}</span></li>
                                <li>{{$t('train.type')}}：<span>{{trainDetail.typeName||$t('c.none')}}</span></li>
                                <li>{{$t('c.examType')}}：<span>{{trainDetail.formName||$t('c.none')}}</span></li>
                                <li>{{$t('c.operatorLevel')}}：<span>{{trainDetail.forLevelName||$t('c.none')}}</span>
                                </li>
                                <li>{{$t('c.startTime')}}：<span>{{(trainDetail.startTime&&trainDetail.startTime.slice(0,-3))||$t('c.none')}}</span></li>
                                <li>{{$t('c.endTime')}}：<span>{{(trainDetail.endTime&&trainDetail.endTime.slice(0,-3))||$t('c.none')}}</span></li>
                                <li><p>{{$t('train.content')}}：</p>
                                    <p class="info-des">{{trainDetail.content||$t('c.none')}}</p></li>
                            </ul>
                        </el-col>
                        <el-col :span="17" style="position: relative">
                            <ul class="info-right">
                                <li>
                                    <el-progress type="circle" :width="100" :percentage="100" color="#59a4cc"
                                                 :show-text="false"></el-progress>
                                    <p class="train-number" style="color: #59a4cc">{{trainAll}}</p>
                                    <p class="train-txt">{{statusArr[0].statusName}}</p>
                                </li>
                                <li>
                                    <el-progress type="circle" :width="100" :percentage="registeredRate"
                                                 color="#0496a6"
                                                 :show-text="false"></el-progress>
                                    <p class="train-number" style="color: #0496a6">{{registered}}</p>
                                    <p class="train-txt">{{statusArr[1].statusName}}</p>
                                </li>
                                <li>
                                    <el-progress type="circle" :width="100" :percentage="normalRate"
                                                 color="#ffb823"
                                                 :show-text="false"></el-progress>
                                    <p class="train-number" style="color: #ffb823">{{normal}}</p>
                                    <p class="train-txt">{{statusArr[2].statusName}}</p>
                                </li>
                                <li>
                                    <el-progress type="circle" :width="100" :percentage="lateRate"
                                                 color="#2e7fa9"
                                                 :show-text="false"></el-progress>
                                    <p class="train-number" style="color: #2e7fa9">{{late}}</p>
                                    <p class="train-txt">{{statusArr[3].statusName}}</p>
                                </li>
                                <li>
                                    <el-progress type="circle" :width="100" :percentage="warningRate"
                                                 color="#f5516b"
                                                 :show-text="false"></el-progress>
                                    <p class="train-number" style="color: #f5516b">{{warning}}</p>
                                    <p class="train-txt">{{statusArr[4].statusName}}</p>
                                </li>
                                <li>
                                    <el-progress type="circle" :width="100" :percentage="absenceRate"
                                                 color="#8d7b6c"
                                                 :show-text="false"></el-progress>
                                    <p class="train-number" style="color: #8d7b6c">{{absence}}</p>
                                    <p class="train-txt">{{statusArr[5].statusName}}</p>
                                </li>

                            </ul>
                        </el-col>
                    </el-row>
                </ui-card>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="16">
                <ui-card :title="$t('train.trainees')" icon="nucfont inuc-menu-assemble" class="ibox">
                    <el-tooltip slot="button" v-if="userInfo.userID==basicInfo.creatorID" class="item" effect="dark" :content="$t('count.exportOffline')"
                                placement="top-start" :hide-after="1000">
                        <a :href="exportUrl" class="export-btn"><i class="nucfont inuc-daochu"></i></a>
                    </el-tooltip>

                    <data-tables class="form-table"
                                 ref="trainTable"
                                 :data="filterData"
                                 :table-props="tableProps"
                                 :page-size="20"
                                 :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                 @filter-change="filterChange"
                    >
                        <el-table-column type="index" width="50" align="center">
                        </el-table-column>
                        <!-- column title -->
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label"
                                         :key="title.label"
                                         align="center"
                                         sortable="custom">
                        </el-table-column>

                        <el-table-column prop="statusName" :label="$t('c.status')" align="center"
                                         column-key="status"
                                         :filters="filterRules"
                                         :filter-method="filterTag"
                                         filter-placement="bottom-end">
                            <template slot-scope="scope">
                                <el-popover
                                    :disabled="scope.row.status!==3 && scope.row.status!==4"
                                    ref="popover"
                                    placement="right"
                                    :title="$t('train.absentReason')"
                                    width="200"
                                    trigger="hover"
                                    :content="scope.row.reason">
                                    <span class="plan-status" :class="getStatus(scope.row.status)" slot="reference">
                                       {{scope.row.statusName}}
                                    </span>
                                </el-popover>
                            </template>
                        </el-table-column>
                    </data-tables>
                </ui-card>
            </el-col>
            <el-col :span="8">
                <ui-panel class="map-panel" :title="$t('train.signArea')" icon="inuc-dingwei">
                    <baidu-map class="bm-map"
                               :center="center"
                               :zoom="16"
                               :scroll-wheel-zoom="true"
                               @ready="onMapReady"
                    >
                        <bm-view class="bm-view"></bm-view>
                        <bm-circle
                            :center="center"
                            :radius="range"
                            stroke-color="#22B9FF"
                            :stroke-opacity="1"
                            :stroke-weight="3"
                            :editing="false"></bm-circle>
                    </baidu-map>
                </ui-panel>
            </el-col>
        </el-row>
    </sub-page>
</template>

<script>
    import api from '@/api';
    import {Ticket} from '@/utils';
    import SubPage from '@components/Subpage';
    import uiPanel from '@components/UIPanel';
    import uiCard from '@components/Statistics/StatisticUICard.vue';

    var echarts = require('echarts');
    export default {
        props: ['planId'],
        data() {
            return {
                trainDetail: {},
                userInfo: {},
                statusArr: [
                    {
                        statusName: this.$t('count.totalPeopleNum')
                    },
                    {
                        statusName: this.$t('count.registered')
                    }, {
                        statusName: this.$t('count.normal')
                    }, {
                        statusName: this.$t('count.late')
                    }, {
                        statusName: this.$t('count.error')
                    }, {
                        statusName: this.$t('count.absence')
                    },
                ],
                trainAll: 0,
                registered: 0,
                normal: 0,
                late: 0,
                warning: 0,
                absence: 0,
                registeredRate: 0,
                normalRate: 0,
                lateRate: 0,
                warningRate: 0,
                absenceRate: 0,
                tableData: [],
                filterData: [],
                tableProps: {
                    border: false,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto"
                },
                currentPage: 1,
                titles: [
                    {
                        prop: 'userName',
                        label: this.$t('c.username')
                    }, {
                        prop: 'accountNo',
                        label: this.$t('c.account')
                    }, {
                        prop: 'orgName',
                        label: this.$t('c.belong')
                    }, {
                        prop: 'postName',
                        label: this.$t('c.position')
                    }
                ],
                // 培训状态status：0已报名，1正常，2迟到，3异常，4缺席
                filterRules: [
                    {text: this.$t('count.registered'), value: 0},
                    {text: this.$t('count.normal'), value: 1},
                    {text: this.$t('count.late'), value: 2},
                    {text: this.$t('count.error'), value: 3},
                    {text: this.$t('count.absence'), value: 4},
                ],
                center: {
                    lng: 116.404, lat: 39.915
                },
                range: 0,
                basicInfo: {},
            }
        },
        created() {
            this.getTrainInfo();
        },
        mounted() {
            if (Ticket.get()) {
                this.userInfo = Ticket.get();
            }
        },
        computed: {
            exportUrl() {
                const ticket = Ticket.get().access_token;
                return `${APIURI}/api/Export/Excel/TrainingOfflineStatisticsExport?id=${this.planId}&access_token=${ticket}`;
            }
        },
        methods: {
            // 获得培训信息
            getTrainInfo() {
                api.getTrainOfflineStatistics(this.planId).then(res => {
                    let data = res.package;
                    if (data) {
                        this.trainDetail = res.package

                        // 基本信息-右侧
                        if (data.trainees.length > 0) {
                            let trainees = res.package.trainees;
                            this.trainAll = trainees.length;
                            trainees.forEach(ele => {
                                if (ele.status === 0) {//已报名
                                    this.registered += 1
                                }
                                if (ele.status === 1) {//正常
                                    this.normal += 1
                                }
                                if (ele.status === 2) {//迟到
                                    this.late += 1
                                }
                                if (ele.status === 3) {//异常
                                    this.warning += 1
                                }
                                if (ele.status === 4) {//缺席
                                    this.absence += 1
                                }
                                ele.postName = ele.postName ? ele.postName : '';
                                ele.gradeName = ele.gradeName ? ele.gradeName : '';
                            });
                            this.registeredRate = this.registered * 100 / this.trainAll;
                            this.normalRate = this.normal * 100 / this.trainAll;
                            this.lateRate = this.late * 100 / this.trainAll;
                            this.warningRate = this.warning * 100 / this.trainAll;
                            this.absenceRate = this.absence * 100 / this.trainAll

                        }
                        //人员信息
                        this.tableData = data.trainees;
                        this.filterData = [...data.trainees];

                        this.$refs.trainTable.$refs.elTable.clearFilter();
                        if (data.content.length > 52) {
                            data.content = data.content.substring(0, 50) + '...'
                        }
                        this.basicInfo = data;

                        //加载地图信息
                        if (this.map) this.setMap(this.basicInfo);

                    }
                })
            },
            filterChange(filters) {
                let status = filters.status;

                if (!status.length) {
                    this.filterData = [...this.tableData];
                    return
                }

                this.filterData = [];
                status.forEach(v => {
                    this.filterData.push(...this.tableData.filter(item => item.status === v));
                })
            },
            filterTag(value, row) {
                return true;
            },
            onMapReady({BMap, map}) {
                let self = this;
                this.BMap = BMap;
                this.map = map;

                map.addControl(new BMap.NavigationControl({
                    type: BMAP_NAVIGATION_CONTROL_SMALL,
                    anchor: BMAP_ANCHOR_TOP_RIGHT
                }));
                map.addControl(new BMap.ScaleControl());

                //加载地图信息
                if (this.basicInfo.coordinate) {
                    this.setMap(this.basicInfo);
                }
            },
            setMap(data) {
                let lat = data.coordinate && data.coordinate.split(',')[0];
                let lng = data.coordinate && data.coordinate.split(',')[1];
                let point = new this.BMap.Point(lng, lat);

                this.range = data.range;

                // 创建标注
                let marker = new this.BMap.Marker(point);
                this.map.addOverlay(marker);
                let label = new this.BMap.Label(data.place,{offset:new this.BMap.Size(20,-10)});
                marker.setLabel(label);

                // 区域圆
                setTimeout(() => {
                    this.center.lat = lat;
                    this.center.lng = lng;
                }, 200)
            },
            getStatus(status) {
                return [
                    'registered',   //0 已报名
                    'normal',       //1 正常
                    'late',         //2 迟到
                    'error',        //3 异常
                    'absence',      //4 缺席
                ][status]
            },
        },
        watch: {},
        components: {
            SubPage,
            uiPanel,
            uiCard
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../style/const';

    .train-detail{
        & /deep/ .ui-card {
            border: 1px solid #ebebed;
            box-shadow: none;
            .card-header {
                border-bottom: 1px solid #ebebed;
            }
        }
        & {
            .participant {
                & /deep/ .card-body {
                    padding: 0;
                }
            }
        }
        & /deep/ .sc-table {
            thead {
                tr {
                    th {
                        background: #fff;
                    }
                }
            }
        }
    }
    .ibox {
        .content_detail {
            display: flex;
            .info-left {
                padding: 20px;
                border-right: 1px solid #e7e7e7;
                li {
                    min-height: 30px;
                    line-height: 30px;
                    display: flex;
                    margin-top: 5px;
                    border-bottom: 1px dashed #e7e7e7;
                    p:first-child {
                        display: inline-block;
                        min-width: 70px;
                        word-wrap: break-word;
                    }
                    p:last-child {
                        flex: 1;
                        overflow: hidden;
                        word-wrap: break-word;
                    }
                    .info-des,
                    span {
                        color: #999;
                    }
                }
            }
            .info-right {
                display: flex;
                padding: 0 0 0 15px;
                position: absolute;
                width: 100%;
                top: 50%;
                transform: translateY(-60%);
                li {
                    margin-top: 60px;
                    display: inline-block;
                    text-align: center;
                    flex: 1;
                    padding: 10px 0;
                    position: relative;
                    .train-number {
                        font-size: 30px;
                        position: absolute;
                        left: 50%;
                        top: 60px;
                        transform: translate(-50%, -50%);
                    }
                    .train-txt {
                        margin-top: 10px;
                        color: #666;
                    }
                }
            }
        }
        .form-table {
            height: 400px;
            display: flex;
            flex: 1;
            flex-direction: column;
        }
    }
    .map-panel {
        display: flex;
        flex-direction: column;
        height: 442px;

        /deep/.panel-body {
            height: 100%;
            padding: 0;
        }
    }
    .bm-map {
        height: 100%;

        .bm-view {
            height: 100%;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
        }

        /deep/ img {
            max-width: none;
        }
    }
    .plan-status {
        display: inline-block;
        color: #fff;
        width: 70px;
        border-radius: 2px;
        font-size: 14px;
        text-align: center;

        &.status {
            background-color: #23b7e5;
        }
        &.registered {
            background-color: #2e7faa;
        }
        &.normal {
            background-color: #FFB822;
        }
        &.late {
            background-color: #0396a6;
        }
        &.error {
            background-color: #c47a76;
        }
        &.absence {
            background-color: #8c7b6c;
        }
    }

    .export-btn {
        float: right;
        margin-right: 20px;
        color: #208acc;
    }
</style>
